import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Impact from './pages/Impact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';

// Admin Pages
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import Posts from './pages/admin/Posts';
import PostEditor from './pages/admin/PostEditor';
import Messages from './pages/admin/Messages';
import Comments from './pages/admin/Comments';
import Settings from './pages/admin/Settings';
import Profile from './pages/admin/Profile';
import Users from './pages/admin/Users';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/portfolio" element={<Layout><Portfolio /></Layout>} />
      <Route path="/impact" element={<Layout><Impact /></Layout>} />
      <Route path="/blog" element={<Layout><Blog /></Layout>} />
      <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={
        <ProtectedRoute><Dashboard /></ProtectedRoute>
      } />
      <Route path="/admin/posts" element={
        <ProtectedRoute><Posts /></ProtectedRoute>
      } />
      <Route path="/admin/posts/new" element={
        <ProtectedRoute><PostEditor /></ProtectedRoute>
      } />
      <Route path="/admin/posts/:id" element={
        <ProtectedRoute><PostEditor /></ProtectedRoute>
      } />
      <Route path="/admin/messages" element={
        <ProtectedRoute><Messages /></ProtectedRoute>
      } />
      <Route path="/admin/comments" element={
        <ProtectedRoute><Comments /></ProtectedRoute>
      } />
      <Route path="/admin/settings" element={
        <ProtectedRoute><Settings /></ProtectedRoute>
      } />
      <Route path="/admin/profile" element={
        <ProtectedRoute><Profile /></ProtectedRoute>
      } />
      <Route path="/admin/users" element={
        <ProtectedRoute><Users /></ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
